import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import OrderStatusMap from '../../components/OrderStatusMap';

import { getOrderStatus } from '../../selectors/orderStatusSelectors';

import styles from './styles.scss';

export function getElementsDimension(pageContentEl, safeZoneEl) {
  const contentLeftPadding = parseInt(
    window.getComputedStyle(pageContentEl).getPropertyValue('padding-left'),
    10,
  );
  const sidePadding = contentLeftPadding * 2;
  const contentWidth = pageContentEl.clientWidth - sidePadding;
  const safeZoneRect = safeZoneEl.getBoundingClientRect();
  const safeZone = {
    top: safeZoneRect.top,
    left: safeZoneRect.left,
    width: safeZoneRect.width,
    height: safeZoneRect.height,
  };

  return {
    contentWidth,
    safeZone,
  };
}

/**
 * A wrapper for the order status content that changes based on if there's a map.
 * This is because the map changes the layout of the page massively.
 */
export function OrderStatusMapWrapper({
  children,
  showMap,
  pinLocations,
  riderVehicleType,
  contentWidth,
  safeZone,
}) {
  let wrapperComponent;
  if (showMap && contentWidth && safeZone) {
    wrapperComponent = (
      <OrderStatusMap
        locations={pinLocations}
        vehicleType={riderVehicleType}
        contentWidth={contentWidth}
        safeZone={safeZone}
      >
        {children}
      </OrderStatusMap>
    );
  } else {
    wrapperComponent = children;
  }

  return <div className={styles.wrapper}>{wrapperComponent}</div>;
}

OrderStatusMapWrapper.defaultProps = {
  riderVehicleType: undefined,
  pinLocations: undefined,
  contentWidth: undefined,
  safeZone: undefined,
  showMap: false,
};

OrderStatusMapWrapper.propTypes = {
  /**
   * The vehicle type of the rider, used for showing relevant map icon
   */
  riderVehicleType: PropTypes.string,
  /**
   * The locations of the rider and customer, used for showing pins on the map
   */
  pinLocations: PropTypes.arrayOf(PropTypes.object.isRequired),
  /**
   * The width of the page content, used to calculate the map offset
   */
  contentWidth: PropTypes.number,
  /**
   * The dimension/location of the safe zone element, used to calculate
   * the map offset and where to place the pins
   */
  safeZone: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  /**
   * Whether the map is showing or not
   */
  showMap: PropTypes.bool,
  /**
   * The content of the status page
   */
  children: PropTypes.node.isRequired,
};

export const mapStateToProps = (state, { pageContentEl, safeZoneEl }) => {
  const status = getOrderStatus(state);
  const showMap = !!(status.showMap && pageContentEl && safeZoneEl);
  const elementsDimension = showMap ? getElementsDimension(pageContentEl, safeZoneEl) : {};

  return {
    riderVehicleType: status.rider && status.rider.vehicleType,
    pinLocations: status.locations,
    showMap,
    ...elementsDimension,
  };
};

export default connect(mapStateToProps)(OrderStatusMapWrapper);
